import { ROUTES } from 'app/config/routes'
import { getUser } from 'app/services/user'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { accessTokenAtom, currentUserAtom, isAuthenticatedAtom } from 'store'

export function PrivateRoute(props: any) {
  const navigate = useNavigate()
  const { children } = props
  const idToken = useAtomValue(accessTokenAtom)
  const [isAuthenticated, setIsAuthenticated] = useAtom(isAuthenticatedAtom)
  const setCurrentUser = useSetAtom(currentUserAtom)
  const setAccessToken = useSetAtom(accessTokenAtom)

  async function init() {
    if (!idToken) {
      return navigate(ROUTES.AUTH.LOGIN)
    }
    try {
      const user = await getUser()
      setCurrentUser(user)
      setIsAuthenticated(true)
    } catch {
      setCurrentUser(null)
      setAccessToken(null)
      setIsAuthenticated(false)
      return navigate(ROUTES.AUTH.LOGIN)
    }
  }

  useEffect(() => {
    init()
  }, [])

  return !isAuthenticated ? (
    <section className="flex h-screen justify-center items-center">
      Loading
    </section>
  ) : (
    children
  )
}
